import http from './http';


/// Makina
export function getMakina() {
    return http.get(`/makina`);
}

export function getMakinaDetail(id) {
    return http.get(`/makina/detail/${id}`);
}

export function createMakina(data) {
    return http.post(`/makina/create`, data);
}

export function updateMakina(id, data) {
    return http.put(`/makina/update/${id}`, data);
}

export function deleteMakina(id) {
    return http.delete(`/makina/delete/${id}`);
}
